export const OPEN_REVIEW = "OPEN_REVIEW";
export const CLOSE_REVIEW_PAGE = "CLOSE_REVIEW_PAGE";
export const REVIEW_PLACE = "REVIEW_PLACE";
export const OPEN_REVIEW_LIST = "OPEN_REVIEW_LIST";
